module.exports = __webpack_public_path__ + "static/img/img-kjsc_ggao.e03bd57f.png";